import React, { useContext, useEffect, useState } from "react";
import "./News.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Common_Heading from "../../../common_components/common_Heading/Common_Heading";
import News_Modal from "./news_Modal/News_Modal";
import { NEWS } from "../../../../utils/luxuryapis/Event/Event";
import { Context } from "../../../../utils/context";

function News() {
  const [modalShow, setModalShow] = React.useState(false);
  const newsData = [
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
  ];

  const { IMG_URL } = useContext(Context);
  const [data, setData] = useState([]);
  const [singleData, setSingleData] = useState({});
  const getData = async () => {
    const res = await NEWS();
    if (res?.success) {
      setData(res?.data?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <section className="News_holder">
        <div className="custom_container">
          <Common_Heading headingText={"IN THE NEWS"} />

          <div className="News_slider_holder">
            <Swiper
              spaceBetween={5}
              slidesPerView={4.2}
              className="news_swiper"
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 2.2,
                },
                768: {
                  slidesPerView: 4.2,
                },
                992: {
                  slidesPerView: 5.2,
                },
              }}
            >
              {data?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="img_holder"
                    onClick={() => {setModalShow(true);setSingleData(item)}}
                  >
                    <img
                      src={IMG_URL + item?.news_images[0]?.image}
                      alt="event"
                      className="enewsImg"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      <News_Modal show={modalShow} onHide={() => setModalShow(false)} data={singleData} IMG_URL={IMG_URL} />
    </>
  );
}

export default News;
